const brasileiraoContent = {
  preview: `The Brasileirão Série A 2025 promises another season of intense competition across 
  Brazil's vast football landscape. Flamengo, the country's most supported club, face challenges 
  from Palmeiras, Atletico Mineiro and Fluminense in a league renowned for its passionate support 
  and attacking football philosophy.`,

  keyStories: [
    {
      title: "Flamengo's Continued Ambition",
      desc: "The Rio giants continue to invest in quality players, maintaining their position as Brazil's most ambitious domestic club."
    },
    {
      title: "Palmeiras' Systematic Excellence",
      desc: "Abel Ferreira's methodical approach has made Palmeiras the model of consistency in Brazilian football."
    },
  ],

  titleContenders: ["Flamengo", "Palmeiras", "Atletico Mineiro", "Fluminense", "Botafogo"],

  fullPreview: `
    <h3>Brasileirão 2025 — Complete Analysis</h3>
    <p>South America's largest league competition runs from April through December, providing 
    football entertainment through Europe's summer break. The Brasileirão's unique format and 
    the passionate rivalries between Brazil's major clubs make it essential viewing for global football fans.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>Flamengo and Palmeiras are projected as the two most likely title winners based on squad 
    investment and recent historical performance in the competition.</p>
  `,
};

export default brasileiraoContent;